import React, { useEffect } from 'react';
import { AppState } from '../store/state';
import { AppDispatch } from '../store/store';
import conferenceSlice from '../store/conference/slice';
import { connect } from 'react-redux';
import { ConferenceState } from '../store/conference/types';
import { ReactComponent as Logo } from '../images/logo.svg';

interface Props {
  conferenceState: ConferenceState;
  unselectTrackAction: () => void;
}

const MaintenancePage: React.FC<Props> = ({ conferenceState, unselectTrackAction }) => {
  useEffect(() => {
    if (conferenceState.currentTrackId) {
      /* If we reach conferences list page and we have a selected track this means we exit track by a strange way and thus by not by clicking 'Exit conference' or so.
          We must clean redux state at this point.
           */
      unselectTrackAction();
    }
  }, []);

  return (
    <div className="bg-gray-100 flex flex-col items-center justify-center min-h-screen text-center px-4">
      <div className="mb-4">
        <Logo />
      </div>
      <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">We'll Be Back Soon</h1>
      <p className="text-lg text-gray-600 mb-6">
        Sorry for the inconvenience. We're performing some maintenance right now. <br />
        Please check back later.
      </p>
      <p className="text-sm text-gray-400">— Thank you for your patience.</p>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  conferenceState: state.conference,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  unselectTrackAction: () => dispatch(conferenceSlice.actions.UNSELECT_TRACK()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MaintenancePage);
